import { render, staticRenderFns } from "./ProductConnection.vue?vue&type=template&id=0658c790&scoped=true"
import script from "./ProductConnection.vue?vue&type=script&lang=js"
export * from "./ProductConnection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0658c790",
  null
  
)

export default component.exports